import React, { useState } from "react";
import WDialog from "../YesNo";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import TonList from "./TonList";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(1),
  },
  weightDialog: {
    display: "flex",
    flexDirection: "column",
    "&>div": {
      marginBottom: theme.spacing(1),
    },
  },
  tonList: {
    flexGrow: 1,
    overflowY: "auto",
  },
}));

const WeightDialog = ({ onClose, w = null, wt = "Ton" }) => {
  const classes = useStyles();
  const [weight, setWeight] = useState(w);
  const [weightType, setWeightType] = useState(wt);
  const handleClose = (agree) => {
    const obj = { weight, weightType };
    if (agree) onClose(obj);
    else onClose(false);
  };
  const handleChangeToggle = (e, value) => {
    setWeight(null);
    setWeightType(value);
  };
  const handleChangeWeightKg = (e) => {
    let { value } = e.target;
    setWeight(value);
  };
  const handleChangeWeightTon = (ton) => {
    setWeight(ton);
    onClose({ weight: ton, weightType });
  };
  return (
    <WDialog
      fullWidth
      title={
        <div>
          <Typography component="h1" variant="h1" className={classes.title}>
            وزن محموله
          </Typography>
          <ToggleButtonGroup
            value={weightType}
            exclusive
            onChange={handleChangeToggle}
            style={{ width: "100%" }}
          >
            <ToggleButton value="Ton" style={{ width: "50%" }}>
              تن
            </ToggleButton>
            <ToggleButton value="Kg" style={{ width: "50%" }}>
              کیلوگرم
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      }
      yes="انتخاب"
      no="صرفنظر"
      onClose={handleClose}
    >
      <div className={classes.weightDialog}>
        {weightType === "Ton" ? (
          <div className={classes.tonList}>
            <TonList onClick={handleChangeWeightTon} selectedWeight={weight} />
          </div>
        ) : null}
        {weightType === "Kg" ? (
          <TextField
            fullWidth
            variant="outlined"
            label="وزن بر حسب کیلوگرم"
            value={weight ? weight : ""}
            onChange={handleChangeWeightKg}
            type="number"
          />
        ) : null}
      </div>
    </WDialog>
  );
};

export default React.memo(WeightDialog);
